import React, { FunctionComponent } from 'react';
import Icon from '../../@shared/icon';
import { iconSize } from '../../../constants/icon.constants';

type THeroCarouselArrowProps = {
  direction: 'previous' | 'next' | 'download';
  onClick: () => void;
};

const GalleryCarouselArrow: FunctionComponent<THeroCarouselArrowProps> = ({ direction, onClick }) => {
  const nextDirection =  direction === 'next' ? 'arrow-chevron-right' : 'action-download';
  const icon = direction === 'previous' ? 'arrow-chevron-left' : nextDirection;
  return (
    <button className={'controls__arrow controls__arrow--' + direction} aria-label={direction + 'slide / item'} onClick={onClick}>
      <Icon
        iconName={icon}
        color="complement"
        size={iconSize.lg}
        extraClassName={`controls__arrow--icon controls__arrow--icon-${direction}`}
      />
    </button>
  );
};

export default GalleryCarouselArrow;
